import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import { MdCheckCircle, MdLock, MdStars, MdWarehouse, MdWarning } from 'react-icons/md';

export default class ApuracaoDepositos extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { loading, dados, tipo } = this.props;

        let Linha = ({ icon, label, valor, valorMuted, children, borderTop, borderBottom = true }) => (
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                py={1.5}
                borderBottom={borderBottom ? '1px solid #eef1f5' : 'none'}
                borderTop={borderTop ? '1px dashed #d7dce3' : 'none'}
                mt={borderTop ? 0.75 : 0}
            >
                <Stack direction="row" alignItems="center" gap={0.7} color="#374151" fontWeight={600}>
                    {icon}
                    <Typography fontSize={13} fontWeight={600}>{label}</Typography>
                </Stack>
                <Stack alignItems="flex-end" gap={0.3}>
                    <Typography fontSize={14} fontWeight={600} color={valorMuted ? '#9ca3af' : '#1f2937'}>{valor}</Typography>
                    {children}
                </Stack>
            </Stack>
        );

        return (
            <>
                {loading ? <Skeleton height={182} variant="rounded" /> :
                    <Stack bgcolor="#f5f7fa" borderRadius={2} overflow={'hidden'}>
                        <Stack direction="row" bgcolor="#ebf1fa" height={40} color="#0A57A3" alignItems="center" gap={1} p={1.2}>
                            <MdWarehouse />
                            <Typography variant="caption"><b>Depósitos</b></Typography>
                            <Box flex={1.0} />
                            <Stack direction="row" bgcolor="#0A57A3" color="white" alignItems="center" p={0.5} borderRadius={2}>
                                <Typography fontSize={10}>{tipo}</Typography>
                            </Stack>
                        </Stack>
                        <Box px={2}>
                            <Linha icon={<MdWarehouse size={13} color="#6b7a92" />} label="Avaria" valor={dados?.avaria?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})} valorMuted={dados?.avaria === 0} >
                                <Stack direction="row" alignItems="center" gap={0.6}>
                                    <Typography fontSize={10} color="#6b7a92">Meta: {dados?.meta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</Typography>
                                    <Stack direction="row" alignItems="center" gap={0.3} color={dados?.dentroMeta ? '#15803d' : '#b40909'}>
                                        {dados?.dentroMeta ? <MdCheckCircle size={11} /> : <MdWarning size={11} />}
                                        <Typography fontSize={10}>{dados?.dentroMeta ? 'Dentro da meta' : 'Fora da meta'}</Typography>
                                    </Stack>
                                </Stack>
                            </Linha>
                            <Linha icon={<MdWarehouse size={13} color="#6b7a92" />} label="Segregado" valor={dados?.segregado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})} valorMuted={dados?.segregado === 0} />
                            {/* <Linha
                                icon={null}
                                label="Soma (Avaria + Segregado)"
                                valor={dados?.total}
                                borderBottom={false}
                            >
                               
                            </Linha> */}
                            <Linha
                                icon={<MdWarehouse size={13} color="#6b7a92" />}
                                label="Comodato"
                                valor={dados?.comodato.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}
                                valorMuted={dados?.comodato === 0}
                            />
                            <Linha
                                icon={<MdWarehouse size={13} color="#6b7a92" />}
                                label="Divergências"
                                valor={dados?.divergencias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}
                                valorMuted={dados?.divergencias === 0}
                            />
                            {/* <Typography fontSize={9} color="#9ca3af" pb={1.5} mt={-1}>(dep. à parte · fora da meta)</Typography> */}
                        </Box>
                    </Stack>
                }
            </>
        );
    }
}
